import React, { memo, useEffect } from 'react';
import { useImmer } from 'use-immer';

const ResultCountDisplay = memo((props) => {
    const [from, setFrom] = useImmer(0);
    const [to, setTo] = useImmer(0);
    const [total, setTotal] = useImmer(0);

    useEffect(() => {
        let currentPage = props.currentPage ?? 0;
        let pageSize = props.pageSize ?? 0;
        let currentStart = currentPage * pageSize;
        let currentResultCount = props.currentResultCount ?? 0;
        let totalResults = props.totalResults ?? 0;

        setFrom(totalResults > 0 ? currentStart + 1 : 0);
        setTo(totalResults > 0 ? currentStart + currentResultCount : 0);
        setTotal(totalResults);
    }, [props.pageSize, props.currentPage, props.currentResultCount, props.totalResults])

    return (
        <div className={(props.className ? props.className : "") + " bg-light small text-center p-1 m-0"}>
            {/*Showing Results: {(props.currentPage * props.pageSize) + 1} to {(props.currentPage * props.pageSize) + props.currentResultCount} of {viewModel.totalResults}*/}
            Showing Results: {from} to {to} of {total}
        </div>
    )
});

export default ResultCountDisplay;